import Api from "@/config/api/signup.js";
import CommonUtil from "@/utils/CommonUtil.js";
import Config from "@/config/Config";
import MemberErrorCode from "@/config/api/member-error-code.js";
import StorageUtil from "@/utils/StorageUtil.js";
import VueCookies from "vue-cookies";
import { STORAGE_KEY } from "@/utils/Constants";

export default {
  state: {
    common: {
      clientId: "",
      sessionKey: "",
      useType: "",
      legal: false,
      retUrl: "",
      retInfo: "",
      redirect: ""
    },
    // PASS 에러 데이터
    passErrorData: {
      code: 0,
      message: "",
      value: {}
    },
    // PASS 결과 정보
    passInfo: {
      birth: "",
      gender: 0,
      name: "",
      phone: "",
      result: false
    }
  },
  mutations: {
    // PASS API 결과 데이터 초기화
    INIT_PASS_ERROR_DATA(state) {
      state.passErrorData.code = 0;
      state.passErrorData.message = "";
    },
    // PASS API 결과 설정
    SET_PASS_ERROR_DATA(state, response) {
      state.passErrorData.code = response.code;
      state.passErrorData.value = response.value;

      const errorMessageInfo = MemberErrorCode.find((obj) => obj.code === response.code);
      if (CommonUtil.isNotEmpty(errorMessageInfo)) {
        state.passErrorData.message = errorMessageInfo.message;
      } else {
        state.passErrorData.message = "오류가 발생하였습니다";
      }
    },
    // PASS 결과 초기화
    INIT_PASS_COMMON_INFO(state) {
      state.common.clientId = "";
      state.common.sessionKey = "";
      state.common.legal = false;
      state.common.retUrl = "";
      state.common.retInfo = "";
      state.common.result = false;
      // state.common.redirect = "";

      state.passInfo.birth = "";
      state.passInfo.gender = 0;
      state.passInfo.name = "";
      state.passInfo.phone = "";
      state.passInfo.result = false;
    },
    // PASS 기본 정보 설정
    SET_PASS_COMMON_INFO(state, response) {
      state.common.clientId = response.client_id;
      state.common.sessionKey = response.session_key;
      state.common.legal = response.legal;
      state.common.useType = response.use_type;
      state.common.retUrl = response.ret_url;
      // state.common.retUrl = "32http://local-my.linker.ac:3000/pass/callback";
      state.common.retInfo = response.req_info;
      state.common.redirect = response.redirect;
      state.common.uniqueId = new Date().getTime();

      StorageUtil.setSessionStorage(STORAGE_KEY.PASS_CERTIFY_YN_STORAGE, "Y");
    },
    // PASS 결과 정보 저장
    ADD_PASS_RESULT_INFO(state, response) {
      state.passInfo.result = response.result;
      state.passInfo.birth = response.birth;
      state.passInfo.gender = response.gender;
      state.passInfo.name = response.name;
      state.passInfo.phone = response.phone;
    },
    // 나이 제한 처리 여부
    SETTING_PASS_RETINFO(state, retinfo) {
      state.retInfo = retinfo;
    }
  },
  actions: {
    // PASS 정보 초기화
    initPASSInfo({ commit }) {
      commit("INIT_PASS_COMMON_INFO");
    },
    // PASS 요청 정보 설정
    async setPASSRequestInfo({ commit, getters }, payload) {
      const param = {
        session_key: payload.session_key,
        use_type: payload.use_type,
        legal: payload.legal,
        domain: payload.domain,
        where_path: CommonUtil.isNotEmpty(payload.where_path) ? payload.where_path : null
      };
      const headerOption = { headers: { "X-Client-Id": getters.clientInfo.ID } };

      // Error Handler Init
      commit("INIT_PASS_ERROR_DATA");
      commit("INIT_PASS_COMMON_INFO");

      ///ios 웹뷰 callback 페이지 디바이스 확인용
      VueCookies.set(Config.DEVICE_TYPE_COOKIE, getters.getDeviceType);

      const { data } = await Api.requestInfoPassVerify(param, headerOption);
      if (data.code === 21000) {
        // Client ID 값 저장
        data.value.client_id = getters.clientInfo.ID;
        data.value.redirect = payload.redirect;
        // legal 세팅
        data.value.legal = payload.legal;
        commit("SET_PASS_COMMON_INFO", data.value);
      } else {
        commit("SET_PASS_ERROR_DATA", data);
      }
    },
    // PASS 결과 값 얻기
    async getPASSCertificationResult({ commit, state }, payload) {
      const param = {
        session_key: state.common.sessionKey,
        use_type: state.common.useType,
        legal: state.common.legal,
        ret_info: payload.retInfo
      };
      const headerOption = { headers: { "X-Client-Id": state.common.clientId } };

      const { data } = await Api.checkPassVerify(param, headerOption);
      if (data.code === 21000) {
        commit("ADD_PASS_RESULT_INFO", data.value);
        commit("UPDATE_PARENT_PHONE", data.value.phone);
        commit("UPDATE_PARENT_NAME", data.value.name);
      } else {
        commit("SET_PASS_ERROR_DATA", data);
      }
    }
  }
};
